import { IpensiiAuthConfig } from '@ipensii/shared/domain-shared';

export const authConfig: (redirectBaseUrl: string) => IpensiiAuthConfig = (redirectBaseUrl) => {
  return {
    redirect_uri: `${redirectBaseUrl}/loggin`,
    authority: 'oauth2',
    client_id: 'ipensii',
    scope: 'openid',
    response_type: 'code',
    code_challenge_method: 'S256',
    grant_type: 'authorization_code',
  };
};
